import { defineStore } from 'pinia'
import { post } from '@/common/request.js'
import { url } from '@/common/config.js'

export const useSystemStore = defineStore('system', {
  state: () => {
    return {}
  },
  getters: {},
  actions: {
    ping() {
      post(url.ping)
        .then((r) => {
          console.log(`ping: ${r.backTimestamp - r.frontTimestamp}ms`)
        })
        .catch((error) => {
          console.error('ping error:', error)
        })
    }
  }
})
